import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  statusCode = '';
  statusText = '';
  message = '';

  constructor(private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    const statusCode = this.activatedRoute.snapshot.queryParamMap.get('statusCode');
    const statusText64 = this.activatedRoute.snapshot.queryParamMap.get('statusText');
    const messagebase64 = this.activatedRoute.snapshot.queryParamMap.get('message');
    if(!messagebase64 || !statusText64 || !statusCode) return;
    const statusText = atob(statusText64);
    const message = atob(messagebase64);
    this.message = message;
    this.statusCode = statusCode;
    this.statusText = statusText;
  }
}
